import {
  CONSUMER_DATA_PRODUCT_REQUEST_LOADER,
  CONSUMER_DATA_PRODUCT_REQUESTS,RESET_CONSUMER_DATA_PRODUCT_REQUESTS
} from '../../constants/reducerTypes';

const initialState = {
  consumerDataProductRequestCollection: [],
  consumerDataProductRequestLoader: false,
  consumerDataProductRequestTotalRows: 0,
  consumerDataProductRequestPageNumber: 1,
  consumerDataProductRequestTotalPages: 1,
  consumerDPRLoader: true,
};

const consumerDataProductRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSUMER_DATA_PRODUCT_REQUESTS: {
      // Defensive: ensure items is always an array
      const { items = [], pageNumber, totalItems, totalPages } = action.payload || {};
      return {
        ...state,
        consumerDataProductRequestCollection:
          pageNumber === 1 ? items : [...state.consumerDataProductRequestCollection, ...items],
        consumerDataProductRequestPageNumber: pageNumber,
        consumerDataProductRequestTotalRows: totalItems,
        consumerDataProductRequestTotalPages: totalPages,
        consumerDataProductRequestLoader: false,
        consumerDPRLoader: false,
      };
    }
    case CONSUMER_DATA_PRODUCT_REQUEST_LOADER:
      return {
        ...state,
        consumerDataProductRequestLoader: action.payload,
      };
    case RESET_CONSUMER_DATA_PRODUCT_REQUESTS: {
      return initialState;
    }
    default:
      return state;
  }
};

export default consumerDataProductRequestReducer;
